import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';

import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import CustomerResetPassword from './components/CustomerResetPassword';
import AssessmentResetPassword from './pages/admin/assessment/AssessmentResetPassword';
import AssessmentPrivateRoute from './pages/admin/AssessmentPrivateRoute';
import ViewMoreDIW from "./pages/viewmore_diw";
import Onboardingdata from "./pages/admin/Onboardingdata";

import OurTeam from './pages/OurTeam';
import CertifiedMicro from './pages/CertifiedMicro';
import CertifiedMid from './pages/CertifiedMid';
import CertifiedLarge from './pages/CertifiedLarge';
import CertifiedEnterprise from './pages/CertifiedEnterprise';
import ThankYou from './pages/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import SearchOrganization from './pages/SearchOrganization';
import NominationForm from './pages/NominationForm';
import AdminDashboard from './pages/admin/AdminDashboard';
import LoginPage from './components/LoginPage';
import ManageOrganizations from './pages/admin/ManageOrganizations';
import ManageNominations from './pages/admin/ManageNominations';
import PrivateRoute from './pages/admin/PrivateRoute';
import MicroOrganizations from './pages/admin/MicroOrganizations';
import MidOrganizations from './pages/admin/MidOrganizations';
import LargeOrganizations from './pages/admin/LargeOrganizations';
import EnterpriseOrganizations from './pages/admin/EnterpriseOrganizations';
import UploadInsights from './pages/UploadInsights';
import OrganizationFramework from './pages/OrganizationFramework';
import OurMethodology from './pages/OurMethodology';
import FAQs from './pages/FAQs';
import AdminInsights from './pages/admin/AdminInsights';
import AddAccount from './pages/admin/AddAccount';
import ViewProfile from './pages/admin/ViewProfile';
import Insights from './pages/Insights';
import News from './pages/Newspage';

import UpcomingEvents from './pages/UpcomingEvents';
import GalleryView from './pages/GalleryView';
import UsageGuide from './pages/usage_guide';
import About from './pages/about';
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import CustomerPrivateRoute from "./pages/admin/CustomerPrivateRoute";

import GetCertified from './pages/get_certified';
import Blogs from "./pages/blogs";
import Work from "./pages/work";
import Engagement from "./pages/engagement";
import Brand from "./pages/brand";
import Thought from "./pages/thought";
import CustomerLogin from './components/Customerlogin';
import CustomerReportPage from './components/CustomerReportPage';
import OnboardingForm from "./pages/onboardingform";

// import ScrollToTopButton from './components/ScrollToTopButton';

//Admin Pages
import Gallery from './pages/admin/Gallery';

//Assessment
import AssessmentLogin from './pages/assessment/AssessmentLogin';
import AssessmentQuestions from './pages/assessment/AssessmentQuestions';
import AssessmentThankYou from './pages/assessment/AssessmentThankYou';

//Certified Organization Pages
import Inypeople from './pages/org/Inypeople';
import Aziro from './pages/org/Aziro';
import Novac from './pages/org/Novac';
import Contustech from './pages/org/Contustech';
import Grootan from './pages/org/Grootan';
import Iris from './pages/org/Iris';
import Abs from './pages/org/Abs';
import Tvsnext from './pages/org/Tvsnext';
import Prochant from './pages/org/Prochant';
import Foodhub from './pages/org/Foodhub';
import TeamDetailing from './pages/org/TeamDetailing';
import KaarTech from './pages/org/KaarTech';
import MithraConsulting from './pages/org/MithraConsulting';
import MNCCorporateSystem from './pages/org/MNCCorporateSystem';
import Finzly from './pages/org/Finzly';
import Softone from './pages/org/Softone';
import Visailabs from './pages/org/Visailabs';
import Walkzero from './pages/org/Walkzero';
import Flyers from "./pages/org/flyers";
import Nutech from "./pages/org/nutech";
import Illumine from "./pages/org/illumine";
import Ashley from "./pages/org/ashley";
import Novin from "./pages/org/novin";
import ChroInterviews from './pages/chroInterviewDetail';
import { chroInterviews } from './pages/chroInterviewsData';
import Hakuna from "./pages/org/hakuna";
import Flat from "./pages/org/flat";
import Infiniti from "./pages/org/infiniti";
import Idea from "./pages/org/idea";
import Icom from "./pages/org/icom";
import Ovation from "./pages/org/ovation";
import Celcom from "./pages/org/celcom";
import S10 from "./pages/org/s10";
import Colan from "./pages/org/colan";
import Sensiple from "./pages/org/sensiple";
import Basilic from "./pages/org/basilic";
import Tychon from "./pages/org/tychon";
import Vmg from "./pages/org/vmg";
import Zuci from "./pages/org/zuci";
import Voltech from "./pages/org/voltech";
import Isource from "./pages/org/isource";
import Mobolutions from "./pages/org/mobolution";
import DashboardPrivateRoute from './pages/admin/DashboardPrivateRoute';
import Anubavam from './pages/org/anubavam';
import Situs from './pages/org/situs';
import Bahwan from './pages/org/bahwan';
import BCT from './pages/org/bct';
import UPS from './pages/org/ups';
import Gyan from './pages/org/gyan';
import Draft from './pages/org/draftronix';
import Epiq from './pages/org/epiq';
import Ad from './pages/org/adam';
import Cm from './pages/org/cmobile';
import El from './pages/org/elglobal';



import Voice from "./pages/voice";
import ViewMore from "./pages/view_more";
import ViewMore1 from "./pages/view_more_1";

//Insights Pages
import InsightsNovac from './pages/insights/employeeengagement/InsightsNovac';
import InsightsAziro from './pages/insights/employeeengagement/InsightsAziro';
import GoodHires from './pages/insights/employeeengagement/GoodHires';
import Ins1 from './pages/nova';
import Ins2 from './pages/aziro';
import Ins3 from './pages/good_hire';
import Ins4 from './pages/employee_engagement';
import Ins5 from './pages/employeeWell';
import Ins6 from './pages/promote';
import Ins7 from './pages/visionary';
import Ins8 from './pages/foster';
import Ins9 from './pages/cultivating';
import Ins10 from './pages/DriveEngagement';
import Ins11 from './pages/ShowCasing';
import Ins12 from './pages/TalentAcquisition';
import Ins13 from './pages/HrVoices';
import Ins14 from './pages/ModernWorkplaces';
import Ins15 from './pages/BuildingWorkplaces';
import Ins16 from './pages/ShapingFuture';
import Ins17 from './pages/BestPractices';
import Ins18 from './pages/WorkLife';
import Ins19 from './pages/employeesurvey';
import Ins20 from './pages/gcc';
import Ins21 from './pages/leaders';
import Ins22 from './pages/ashley';
import Ins24 from './pages/met';
import Ins25 from './pages/beyond';
import Ins26 from './pages/hug';

import Ins23 from './pages/manu';
import Qr from "./pages/qr";

//Assessment Admin
import AssessmentDashboard from './pages/admin/assessment/AssessmentDashboard';
import Quizzes from './pages/admin/assessment/Quizzes';
import Questions from './pages/admin/assessment/Questions';
import AddCompanies from './pages/admin/assessment/AddCompanies';
import Companiesreport from './pages/admin/assessment/Companyreport';
import Employees from './pages/admin/assessment/EmployeeReport';

import AssessmentTaken from './pages/admin/assessment/AssessmentTaken';
import ViewDetails from './pages/admin/assessment/ViewDetails';
import AssessmentAdminLoginPage from './pages/admin/assessment/AssessmentAdminLoginPage';
import AssessmentReportPage from './pages/admin/assessment/AssessmentReportPage';
import './App.css';

// Wrapper for admin login to keep route structure
function AdminLogin() {
  return <LoginPage />;
}

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  // Hide header/footer for ALL assessment pages: /assessment/:companySlug/login,
  // /assessment/questions, /assessment/thank-you, etc.
  const isAssessmentPage = location.pathname.startsWith('/assessment/');
  const isCustomerPage = location.pathname.startsWith('/customer');
  // Hide header/footer on the onboarding form page
  const isOnboardingPage = location.pathname.startsWith('/onboardingform');

  const hideLayout = isAdminRoute || isAssessmentPage || isCustomerPage || isOnboardingPage;

  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Header />}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/customer/reset-password/:token" element={<CustomerResetPassword />} />

        <Route path="/team" element={<OurTeam />} />
        <Route path="/certified" element={<Navigate to="/certified/micro" replace />} />
        <Route path="/certified/micro" element={<CertifiedMicro />} />
        <Route path="/certified/mid" element={<CertifiedMid />} />
        <Route path="/certified/large" element={<CertifiedLarge />} />
         <Route
          path="/chro-interviews"
          element={<ChroInterviews />}
        />

        {chroInterviews.map((item) => (
          <Route
            key={item.slug}
            path={item.path}
            element={<ChroInterviews />}
          />
        ))}
        <Route path="/certified/enterprise" element={<CertifiedEnterprise />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/search-organization" element={<SearchOrganization />} />
        <Route path="/nominate" element={<NominationForm />} />
        <Route path="/upload-insights" element={<UploadInsights />} />
        <Route path="/onboardingform" element={<OnboardingForm />} />
        <Route path="/organization-framework" element={<OrganizationFramework />} />
        <Route path="/our-methodology" element={<OurMethodology />} />
        <Route path="/get-certified" element={<GetCertified />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/news" element={<News />} />
        <Route path="/upcoming-events" element={<UpcomingEvents />} />
        <Route path="/gallery" element={<GalleryView />} />
        <Route path="/usage-guide" element={<UsageGuide />} />
        <Route path="/what-we-do" element={<About />} />
        <Route path="/admin/customerlogin" element={<CustomerLogin />} />
        <Route path="/admin/reset-password/:token" element={<ResetPassword />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/organizations" element={<PrivateRoute><ManageOrganizations /></PrivateRoute>} />
        <Route path="/admin/nominations" element={<PrivateRoute><ManageNominations /></PrivateRoute>} />
        <Route path="/admin/micro-organizations" element={<PrivateRoute><MicroOrganizations /></PrivateRoute>} />
        <Route path="/admin/mid-organizations" element={<PrivateRoute><MidOrganizations /></PrivateRoute>} />
        <Route path="/admin/large-organizations" element={<PrivateRoute><LargeOrganizations /></PrivateRoute>} />
        <Route path="/admin/enterprise-organizations" element={<PrivateRoute><EnterpriseOrganizations /></PrivateRoute>} />
        <Route path="/admin/insights" element={<PrivateRoute><AdminInsights /></PrivateRoute>} />
        <Route path="/admin/add-account" element={<PrivateRoute><AddAccount /></PrivateRoute>} />
        <Route path="/admin/view-profile" element={<PrivateRoute><ViewProfile /></PrivateRoute>} />
        <Route path="/admin/gallery" element={<PrivateRoute><Gallery /></PrivateRoute>} />
        <Route path="/viewmore-diw" element={<ViewMoreDIW />} />
        <Route path="/admin/onboardingdata" element={<Onboardingdata />} />

        {/* Assessment route */}
        <Route path="/assessment/:companySlug/login" element={<AssessmentLogin />} />
        <Route path="/assessment/questions" element={<AssessmentQuestions />} />
        <Route path="/assessment/thank-you" element={<AssessmentThankYou />} />
        <Route
          path="/customer/dashboard"
          element={
            <CustomerPrivateRoute>
              <CustomerReportPage />
            </CustomerPrivateRoute>
          }
        />

        {/* Certified Organization Pages */}
        <Route path="/org/inypeople" element={<Inypeople />} />
        <Route path="/org/aziro" element={<Aziro />} />
        <Route path="/org/novac" element={<Novac />} />
        <Route path="/org/contustech" element={<Contustech />} />
        <Route path="/org/grootan" element={<Grootan />} />
        <Route path="/org/iris" element={<Iris />} />
        <Route path="/org/abs" element={<Abs />} />
        <Route path="/org/tvsnext" element={<Tvsnext />} />
        <Route path="/org/prochant" element={<Prochant />} />
        <Route path="/org/foodhub" element={<Foodhub />} />
        <Route path="/org/teamdetailing" element={<TeamDetailing />} />
        <Route path="/org/kaartech" element={<KaarTech />} />
        <Route path="/org/mithraconsulting" element={<MithraConsulting />} />
        <Route path="/org/mnccorporatesystem" element={<MNCCorporateSystem />} />
        <Route path="/org/finzly" element={<Finzly />} />
         <Route path="/org/adamsbridge" element={<Ad />} />
         <Route path="/org/cmobile" element={<Cm />} />
         <Route path="/org/elixir" element={<El />} />
        
        <Route path="/org/softone" element={<Softone />} />
        <Route path="/org/visailabs" element={<Visailabs />} />
        <Route path="/org/walkzero" element={<Walkzero />} />
        <Route path="org/flyers" element={<Flyers />} />
        <Route path="/org/nutech" element={<Nutech />} />
        <Route path="/org/illumine" element={<Illumine />} />
        <Route path="/org/ashley" element={<Ashley />} />
        <Route path="/org/novintiX" element={<Novin />} />
        <Route path="/org/hakuna" element={<Hakuna />} />
        <Route path="/org/flatirons" element={<Flat />} />
        <Route path="/org/infiniti" element={<Infiniti />} />
        <Route path="/org/idea" element={<Idea />} />
        <Route path="/org/icom" element={<Icom />} />
        <Route path="/org/ovation" element={<Ovation />} />
        <Route path="/org/celcom" element={<Celcom />} />
        <Route path="/org/s10" element={<S10 />} />
        <Route path="/org/colan-infotech" element={<Colan />} />
        <Route path="/org/sensiple" element={<Sensiple />} />
        <Route path="/org/basilic" element={<Basilic />} />
        <Route path="/org/tychon" element={<Tychon />} />
        <Route path="/org/vmg" element={<Vmg />} />
        <Route path="/org/zuci" element={<Zuci />} />
        <Route path="/org/voltech" element={<Voltech />} />
        <Route path="/org/mobolution" element={<Mobolutions />} />
        <Route path="/org/anubavam" element={<Anubavam />} />
        <Route path="/org/situs" element={<Situs />} />
        <Route path="/org/bahwan" element={<Bahwan />} />
        <Route path="/org/gyan" element={<Gyan />} />
        <Route path="/org/isource" element={<Isource />} />
        <Route path="/org/bct" element={<BCT />} />
        <Route path="/org/ups" element={<UPS />} />
        <Route path="/org/draftronix" element={<Draft />} />
        <Route path="/org/epiqindia" element={<Epiq />} />

        {/* Insights Pages */}
        <Route path="/insights/employeeengagement/novac" element={<InsightsNovac />} />
        <Route path="/insights/employeeengagement/aziro" element={<InsightsAziro />} />
        <Route path="/insights/employeeengagement/goodhires" element={<GoodHires />} />
        <Route path="/novac-tech" element={<Ins1 />} />
        <Route path="/aziro-tech" element={<Ins2 />} />
        <Route path="/good-hire" element={<Ins3 />} />
        <Route path="/employee-engagement" element={<Ins4 />} />
        <Route path="/employee-well" element={<Ins5 />} />
        <Route path="/promote-tech" element={<Ins6 />} />
        <Route path="/visionary-tech" element={<Ins7 />} />
        <Route path="/foster-environment" element={<Ins8 />} />
        <Route path="/learning-culture" element={<Ins9 />} />
        <Route path="/drive-management" element={<Ins10 />} />
        <Route path="/show-casing" element={<Ins11 />} />
        <Route path="/talent-acquisition" element={<Ins12 />} />
        <Route path="/hr-voices" element={<Ins13 />} />
        <Route path="/modern-workplaces" element={<Ins14 />} />
        <Route path="/building-workplaces" element={<Ins15 />} />
        <Route path="/shaping-future" element={<Ins16 />} />
        <Route path="/best-practices" element={<Ins17 />} />
        <Route path="/worklife-balance" element={<Ins18 />} />
        <Route path="/employee-survey" element={<Ins19 />} />
        <Route path="/gcc" element={<Ins20 />} />
        <Route path="/leaders" element={<Ins21 />} />
        <Route path="/ashley" element={<Ins22 />} />
        <Route path="/manufacture" element={<Ins23 />} />
        <Route path="/employeeproductivity" element={<Ins24 />} />
         <Route path="/beyondsalaryhikes" element={<Ins25 />} />
           <Route path="/hugging" element={<Ins26 />} />
        <Route path="/qr" element={<Qr />} />

        <Route path="/voice" element={<Voice />} />
        <Route path="/view-more" element={<ViewMore />} />
        <Route path="/view-more-1" element={<ViewMore1 />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/work" element={<Work />} />
        <Route path="/engagement" element={<Engagement />} />
        <Route path="/brand" element={<Brand />} />
        <Route path="/thought" element={<Thought />} />

        {/* Assessment Admin */}
        <Route path="/admin/assessment/login" element={<AssessmentAdminLoginPage />} />
        <Route path="/admin/assessment/reset-password/:token" element={<AssessmentResetPassword />} />
        <Route path="/admin/assessment/dashboard" element={<AssessmentPrivateRoute><AssessmentDashboard /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment" element={<AssessmentPrivateRoute><AssessmentDashboard /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/quizzes" element={<AssessmentPrivateRoute><Quizzes /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/questions" element={<AssessmentPrivateRoute><Questions /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/add-companies" element={<AssessmentPrivateRoute><AddCompanies /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/company-report" element={<AssessmentPrivateRoute><Companiesreport /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/employees" element={<AssessmentPrivateRoute><Employees /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/assessment-taken" element={<AssessmentPrivateRoute><AssessmentTaken /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/view-details" element={<AssessmentPrivateRoute><ViewDetails /></AssessmentPrivateRoute>} />
        <Route path="/admin/assessment/report" element={<AssessmentPrivateRoute><AssessmentReportPage /></AssessmentPrivateRoute>} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;